import React, { useContext, useEffect, useRef, useState } from "react";

import styled from "styled-components/macro";

import API from "Signups/API";
import { useIsSignupClosed } from "Signups/SharedComponents/useIsSignupClosed";
import { SignupsAppState } from "Signups/state";
import { useIsSignupEditMode } from "Signups/stateHooks";
import { motion } from "framer-motion";

import FnrButton from "UI/FnrButton3";
import FnrIconButton from "UI/FnrIconButton";
import FnrInput from "UI/FnrInput";
import { colors } from "UI/colors";
export default function Title() {
  const [
    {
      currentSignupList: { ID, title },
    },
    dispatch,
  ] = useContext(SignupsAppState);
  const { isClosed, isArchived } = useIsSignupClosed();
  const { isSignupEditMode: canEditTitle } = useIsSignupEditMode();

  const [isEditing, setIsEditing] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  const [stagedTitle, setStagedTitle] = useState(title);

  const inputRef = useRef();

  const saveTitle = (e) => {
    e.preventDefault();

    setIsSaving(true);
    API.editTitle(ID, stagedTitle)
      .then(() => {
        dispatch({
          type: "Update Edit Signup Info",
          key: "title",
          value: stagedTitle,
        });
        setIsSaving(false);
        setIsEditing(false);
      })
      .catch((e) => {
        console.error(e);
        setIsSaving(false);
      });
  };

  const canSave = true;

  useEffect(() => {
    if (isEditing) inputRef.current.focus();
  }, [isEditing]);

  return (
    <Container>
      <TitleReadonlyContainer>
        <TitleReadonly style={{ opacity: isEditing ? 0 : 1 }}>
          <TitleText>{title}</TitleText>

          {!isArchived && canEditTitle && (
            <EditButton
              onClick={() => setIsEditing(true)}
              aria-label="Edit Item Title"
              icon="fa-pencil fas"
              color={colors.fnBlue}
            />
          )}
        </TitleReadonly>
        {isClosed && <ClosedIndicator>Closed</ClosedIndicator>}
      </TitleReadonlyContainer>

      {canEditTitle && (
        <Form
          onSubmit={saveTitle}
          style={{ display: isEditing ? "flex" : "none" }}
        >
          <FnrInput
            ref={inputRef}
            value={stagedTitle}
            onChange={setStagedTitle}
            disabled={isSaving}
            autoFocus
            size="small"
            inputStyle={{
              fontSize: 21,
              fontWeight: 400,
              paddingRight: 136,
              color: "#15436a",
            }}
            style={{ borderRadius: 9 }}
          />
          <ButtonsContainer>
            <FnrButton
              text="Cancel"
              size="small"
              borderRadius={4}
              disabled={isSaving}
              onClick={() => setIsEditing(false)}
              style={{ marginRight: "0.3rem" }}
            />
            <FnrButton
              type="submit"
              text="Save"
              color="green"
              size="small"
              borderRadius={4}
              disabled={!canSave}
              loading={isSaving}
            />
          </ButtonsContainer>
        </Form>
      )}
    </Container>
  );
}

const Container = styled.div`
  font-size: 18px;
  font-weight: 400;
  display: flex;
  align-items: center;
  margin-left: 0.3rem;
  flex-grow: 1;
`;

const TitleReadonlyContainer = styled(motion.div)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-grow: 1;
  padding-left: 4px;
`;

const TitleReadonly = styled.div`
  padding-left: 7px; // so title doesn't move when goes into edit mode
  padding-top: 1px; // so title doesn't move when goes into edit mode
  display: flex;
  align-items: center;

  @media screen and (max-width: 500px) {
    padding-left: 3px;
  }
`;

const TitleText = styled.h3`
  font-size: 21px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  // TODO gross
  max-width: 150px;
  @media screen and (max-width: 500px) {
    max-width: 350px;
  }
  @media screen and (max-width: 450px) {
    max-width: 300px;
  }

  @media (min-width: 1140px) {
    max-width: 240px;
  }
  @media (min-width: 1200px) {
    max-width: 330px;
  }
  @media (min-width: 1400px) {
    max-width: 540px;
  }
  @media (min-width: 1480px) {
    max-width: 410px;
  }
`;

// styled(FnrButton)
const EditButton = styled(FnrIconButton)`
  margin-left: 0.5rem;
  margin-right: 0.3rem;
  font-size: 13px;
  cursor: pointer;
  transition: 0.2s;
  opacity: 0;
  background-color: transparent;
  color: ${colors.fnBlue500};
  border-radius: 50%;
  height: 24px;
  width: 24px;
  line-height: 24px;

  ${Container}:hover & {
    opacity: 1;
  }

  &:hover {
    background: ${colors.fnBlue500};
    color: white;
    transform: scale(1.2);
  }

  &:active {
    transform: scale(1);
  }
`;

const ClosedIndicator = styled.div`
  display: inline-block;
  font-size: small;
  font-weight: bold;
  border-radius: 0.7rem;
  background-color: ${colors.fnYellow};
  color: ${colors.fnGray800};
  box-shadow: rgba(0, 0, 0, 0.2) 1px 1px 3px;
  padding: 0.2rem 0.6rem;
  margin: 0.2rem 0.2rem 0;
  text-align: right;
`;

// ${BoardTitle}:hover & {
//     opacity: 1;
//   }
const Form = styled(motion.form)`
  display: flex;
  align-items: center;
  position: absolute;
  margin-left: 1px;

  // TODO gross
  max-width: 350px;
  @media (min-width: 1140px) {
    max-width: 450px;
  }

  @media screen and (max-width: 500px) {
    max-width: 100%;
    width: calc(100% - 1.5rem);
  }
`;

const ButtonsContainer = styled.div`
  position: absolute;
  display: flex;
  right: 0.3rem;
  display: flex;
`;